module.exports = __webpack_public_path__ + "static/mkl-216569594f78056e85c3796c7ef6f4e5.jpeg";